import { useEffect, useState } from "react";
import { Button, Col, Dropdown, Form, Modal, Row } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { adminConfig } from "../../../utils/adminConfig";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { ThreeDot } from "../../../assets/images";
import Select from "react-select";

export default function AddEscapeBucksProduct() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    categoryId: "",
    userId: {},
    name: "",
    price: "",
  });
  const [allProducts, setAllProducts] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [corporateUsers, setCorporateUsers] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [filters, setFilters] = useState({
    userId: "",
    categoryId: "",
  });

  useEffect(() => {
    getAllProducts();
    getCorporateUsers();
    getProductCategories();
  }, []);

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFilterSearch = () => {
    getAllProducts(filters);
  };

  const addNewProduct = (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(formData, "formData")
    let data = {
      categoryId: formData.categoryId,
      userId: formData.userId.value,
      name: formData.name,
      price: formData.price,

    }

    axios
      .post(
        "/escape-bucks/add-new-escape-bucks-product",
        data,
        adminConfig(),
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          setFormData({
            categoryId: "",
            userId: "",
            name: "",
            price: "",
          });
          getAllProducts();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const getAllProducts = (filterParams = {}) => {
    setLoading(true);

    let url = "/escape-bucks/escape-bucks-products-for-admin";
    const query = new URLSearchParams();

    if (filterParams.userId) query.append("userId", filterParams.userId);
    if (filterParams.categoryId) query.append("categoryId", filterParams.categoryId);
    const queryString = query.toString();
    if (queryString) url = `${url}?${queryString}`;

    axios
      .get(url, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setAllProducts(res.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const getProductCategories = () => {
    axios
      .get("/escape-bucks/get-product-categories?status='true'", adminConfig())
      .then((res) => {
        if (res.data.status) {
          setProductCategories(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getCorporateUsers = () => {
    axios
      .get("/get-all-corporate-tvi-users", adminConfig())
      .then((res) => {
        if (res.data.status) {
          setCorporateUsers(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const toggleStatus = (id) => {
    setLoading(true);
    axios
      .patch(
        `/escape-bucks/escape-bucks-product/toggle/${id}`,
        {},
        adminConfig(),
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          getAllProducts();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Price",
      selector: (row) => "$" + row.price,
    },
    {
      name: "Corporate User",
      selector: (row) => row.corporateUserName,
    },
    {
      name: "Product Category",
      selector: (row) => row.productCategoryName,
    },
    {
      name: "Status",
      selector: (row) => (row.status ? "Active" : "Inactive"),
    },
    {
      name: "Total Code",
      selector: (row) => row.totalCode,
    },
    {
      name: "Available Code",
      // selector: (row) => row.availableCode,
      selector: (row) => (
        <div>
          {row?.availableCode < 25 ? <>
            <div className="text-white bg-danger rounded-circle" style={{padding:(row?.availableCode?.toString()?.length > 1)?"4px 7px 7px 8px":"3px 11px 6px"}}>
              {row?.availableCode}
              
            </div></> :
            row?.availableCode > 25 && row?.availableCode < 50 ? <>
              <div className="text-white bg-warning rounded-circle 44" style={{padding:(row?.availableCode?.toString()?.length > 1)?"4px 7px 7px 8px":"3px 11px 6px"}}>
                {row?.availableCode}
              </div></> :
              <div>
                {row?.availableCode}
              </div>}
        </div>
      )
    },
    {
      name: "Redeem Code",
      selector: (row) => row.redeemedCode,
    },

    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                toggleStatus(row._id);
              }}
            >
              {row.status ? "Inactive" : "Active"}
            </div>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                const { name, price, userId, categoryId, _id } = row;
                let findUser = corporateUsers.find((item) => item?.userId == userId);

                setFormData({
                  name,
                  price,
                  userId: {
                    value: userId,
                    label: `${findUser?.username} (${findUser?.userEmail} , ${findUser?.userNameAttr})`
                  },
                  categoryId,
                  id: _id,
                });
                setShowEditModal(true);
              }}
            >
              Edit
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "90px",
    },
  ];

  const updateProduct = (e) => {
    e.preventDefault();
    setLoading(true);

    let data = {
      name: formData.name,
      price: formData.price,
      userId: formData.userId.value,
      categoryId: formData.categoryId
    }

    axios
      .patch(
        "/escape-bucks/update-escape-bucks-product",
        data,
        adminConfig(),
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          handleClose();
          getAllProducts();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleClose = () => {
    setShowEditModal(false);
    setFormData({
      name: "",
      price: "",
      userId: "",
      categoryId: ""
    });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <Modal show={showEditModal} centered>
        <Modal.Header>
          <Modal.Title>Update Commision</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={updateProduct}>

            <Form.Group className="mb-3">
              <Form.Label>Corporate User</Form.Label>
              {/* <Form.Control
                as="select"
                className="select_control"
                required
                name="userId"
                value={formData.userId}
                onChange={handleOnChange}
              >
                <option value="" disabled>
                  Select User
                </option>
                {corporateUsers.map((user) => (
                  <option
                    key={user.userId}
                    value={user.userId}
                  >
                    {user.username } ({user?.userEmail})
                  </option>
                ))}
              </Form.Control> */}

              <Select
                options={
                  corporateUsers.map((user) => ({
                    value: user.userId,
                    label: `${user.username} (${user.userEmail} , ${user.userNameAttr})`,
                  }))
                }
                name="userId"
                placeholder="Select User"
                value={(formData.userId?.value) ? formData.userId : null}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    userId: e,
                  });
                }}
                required
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Product Category Name</Form.Label>
              <Form.Control
                as="select"
                className="select_control"
                required
                name="categoryId"
                value={formData.categoryId}
                onChange={handleOnChange}
              >
                <option value="" disabled>
                  Select category
                </option>
                {productCategories.map((category) => (
                  <option
                    key={category._id}
                    value={category._id}
                  >
                    {category.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleOnChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                min={0}
                placeholder="Price"
                required
                name="price"
                value={formData.price}
                onChange={handleOnChange}
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-3">
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="mx-3" type="submit" variant="primary">
                Update
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="cert_det_inner">
              <h2>Add Escape Credits Product</h2>
            </div>
            <Form onSubmit={addNewProduct}>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Corporate User</Form.Label>
                    {/* <Form.Control
                      as="select"
                      className="select_control"
                      required
                      name="userId"
                      value={formData.userId}
                      onChange={handleOnChange}
                    >
                      <option value="" disabled>
                        Select User
                      </option>
                      {corporateUsers.map((user) => (
                        <option
                          key={user.userId}
                          value={user.userId}
                        >
                          {user.username } ({user?.userEmail})
                        </option>
                      ))}
                    </Form.Control> */}

                    <Select
                      options={
                        corporateUsers.map((user) => ({
                          value: user.userId,
                          label: `${user.username} (${user.userEmail} , ${user.userNameAttr})`,
                        }))
                      }
                      name="userId"
                      placeholder="Select User"
                      value={(formData.userId?.value) ? formData.userId : null}
                      onChange={(event) => {
                        setFormData({
                          ...formData,
                          userId: event,
                        });
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Product Category Name</Form.Label>
                    <Form.Control
                      as="select"
                      className="select_control"
                      required
                      name="categoryId"
                      value={formData.categoryId}
                      onChange={handleOnChange}
                    >
                      <option value="" disabled>
                        Select category
                      </option>
                      {productCategories.map((category) => (
                        <option
                          key={category._id}
                          value={category._id}
                        >
                          {category.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Product Name"
                      required
                      name="name"
                      value={formData.name}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Product Price</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Product Price"
                      required
                      name="price"
                      value={formData.price}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="sub_but mt-3">
                <button type="submit" className="add_but submit_buttt mt-0">
                  Submit
                </button>
              </div>
            </Form>
            <div className="cert_det_inner">
              <h2>Escape Credits Product Lists</h2>

              <Form className="mb-3">
                <Row className="align-items-end gx-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Corporate User</Form.Label>
                      <Form.Control
                        as="select"
                        name="userId"
                        value={filters.userId}
                        onChange={handleFilterChange}
                      >
                        <option value="">All Users</option>
                        {corporateUsers.map((user) => (
                          <option key={user.userId} value={user.userId}>
                            {user.username}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Product Category</Form.Label>
                      <Form.Control
                        as="select"
                        name="categoryId"
                        value={filters.categoryId}
                        onChange={handleFilterChange}
                      >
                        <option value="">All Categories</option>
                        {productCategories.map((category) => (
                          <option key={category._id} value={category._id}>
                            {category.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Button variant="primary" onClick={handleFilterSearch}>
                      Search
                    </Button>
                  </Col>
                </Row>
              </Form>

              <DataTable
                columns={columns}
                data={allProducts}
                pagination
                striped
                responsive
                customStyles={customStyles}
                subHeaderAlign="right"
                subHeaderWrap
              />
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};
